export enum AccommodationBadgeType {
    NewAccommodation,
    InstantReservation,
    ConfirmationUpTo24Hours,
    PromotedOnTV,
}
